import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useContext } from 'react';
import type { HTMLTagProps } from '../../../../types';
import { BottomDrawerContext } from '..';
type BottomDrawerHandleProps = HTMLTagProps<'div'>;

//* 스와이프 닫기는 HandleWrapper가 처리하므로 손잡이 자체는 장식이다
export const Handle = t0 => {
  const $ = _c(8);
  let className;
  let restProps;
  if ($[0] !== t0) {
    ({
      className,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = restProps;
  } else {
    className = $[1];
    restProps = $[2];
  }
  const context = useContext(BottomDrawerContext);
  if (!context) {
    throw new Error("BottomDrawer.Handle\uC740 BottomDrawer \uB0B4\uBD80\uC5D0\uC11C\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.");
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("h-4 w-44 cursor-pointer bg-Gray-300 transition-colors hover:bg-Gray-400 active:bg-Gray-500", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== restProps || $[6] !== t1) {
    t2 = <div {...restProps} aria-hidden="true" className={t1} />;
    $[5] = restProps;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};